import React from 'react';
import PropTypes, { object } from 'prop-types';

import { Text } from '../../../Elements/Elements';
import TrendView from '../../parts/TrendView/TrendView';

import classes from './TrendBlock.module.scss';

const TrendBlock = ({ trendData }) => {
  return (
    <div className={classes.box}>
      {trendData.map(trend => (
        <div className={classes.trend} key={trend.title}>
          <Text className={classes.name}>{trend.title}</Text>
          <Text className={classes.amount}>{trend.curData}</Text>
          <TrendView trend={trend.trendData} />
        </div>
      ))}
    </div>
  );
};

TrendBlock.propTypes = {
  trendData: PropTypes.arrayOf(object)
};

export default TrendBlock;
